import type { Season, Outfit } from '../types';

// 빈 시즌 의상 — 클린 슬레이트
export const SEASON_OUTFITS: Outfit[] = [];

const NOW = Date.now();
const ONE_MONTH = 30 * 24 * 60 * 60 * 1000;

export const SEASONS: Season[] = [
  { id: 'spring', name: '🌸 벚꽃 시즌', motif: 'spring', startAt: NOW, endAt: NOW + ONE_MONTH, outfitIds: [] },
  { id: 'summer', name: '🏖️ 여름 시즌', motif: 'summer', startAt: NOW + ONE_MONTH, endAt: NOW + 2 * ONE_MONTH, outfitIds: [] },
  { id: 'autumn', name: '🍁 가을 시즌', motif: 'autumn', startAt: NOW + 2 * ONE_MONTH, endAt: NOW + 3 * ONE_MONTH, outfitIds: [] },
  { id: 'winter', name: '⛄ 겨울 시즌', motif: 'winter', startAt: NOW + 3 * ONE_MONTH, endAt: NOW + 4 * ONE_MONTH, outfitIds: [] },
];

export const SEASONS_BY_ID: Record<string, Season> = Object.fromEntries(SEASONS.map(s => [s.id, s]));

export function currentSeason(): Season {
  const now = Date.now();
  return SEASONS.find(s => now >= s.startAt && now <= s.endAt) ?? SEASONS[0];
}
